import { createContext } from "react";

export const ThemeSelectorContext = createContext({
  client: null,
});
